module.exports = __webpack_public_path__ + "static/img/zhcg54.2d35967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhcg54.png
// module id = T4Jf
// module chunks = 73